<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('bank') }}</div>
      <div>
        <button
          class="btn-blue"
          @click.prevent.stop="onEditBank(bankDetails.bank_id)"
        >{{ $t('edit') }}</button>
        <router-link class="btn-blue" to="bank">{{ $t('bank') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="col-lg-2 col-xl-3 text-center pt-4">
          <!-- <img src="@/assets/img/icons/userProfile.png" class="w-50" alt /> -->
          <img
            v-if=" bankDetails.bank_logo_url && bankDetails.bank_logo_url.length == 0"
            src="@/assets/img/icons/userProfile.png"
            class="w-50"
            alt
          />
          <img v-else :src="BASE_URL+bankDetails.bank_logo_url" class="w-50" alt />
        </div>
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('bank',1) }} {{ $tc('name') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="bankDetails.bank_name" class="mr-3">{{bankDetails.bank_name}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('bank',1) }} {{ $tc('address') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="bankDetails.bank_address" class="mr-3">{{bankDetails.bank_address}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('country') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="selected.Country" class="mr-3">{{selected.Country}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('state',1) }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="selected.State" class="mr-3">{{selected.State}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('city',1) }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="selected.City" class="mr-3">{{selected.City}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('bank') }} {{ $tc('active') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="bankDetails.bank_is_active=='Y'" class="mr-3">{{$t('yes')}}</span>
            <span v-else class="mr-3">{{$t('no')}}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="bankDetails.created_at" class="mr-3">{{bankDetails.created_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="bankDetails.created_by" class="mr-3">{{bankDetails.created_by}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="bankDetails.updated_at" class="mr-3">{{bankDetails.updated_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="bankDetails.updated_by" class="mr-3">{{bankDetails.updated_by}}</span>
            <span v-else class="mr-3">-</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";

const selected = {
  Country: "",
  State: "",
  City: ""
};

export default {
  data() {
    return {
      roleID: "",
      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities"
      },
      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states"
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      },
      selected: selected,
      items: [],
      bankDetails: []
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;

    const { bank_id } = this.$route.query;

    // this.getCountriesList();

    if (bank_id) {
      this.getBankDetails(bank_id);
    } else {
      const { bank_id } = this.$route.query;
      this.bank_id = this.$route.query.user_id;

      if (bank_id) {
        this.getBankDetails(bank_id);
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {},
  methods: {
    getBankDetails: function(bank_id) {
      MarketingService.getBankDetails({ bank_id }).then(response => {
        const { data } = response;
        if (data.Records) {
          this.bankDetails = {
            ...this.bankDetails,
            ...data.Records[0]
          };
          // console.log("bankDetails :", this.bankDetails);
          this.getCountriesList(this.bankDetails.country_id || null);
          this.getStatesList(
            this.bankDetails.country_id || null,
            this.bankDetails.state_id || null
          );
          this.getCitiesList(
            this.bankDetails.state_id || null,
            this.bankDetails.city_id || null
          );
        }
      });
    },
    onEditBank: function(bank) {
      // console.log("bank.bank_id :", bank);
      this.$router.push({
        path: "/marketing/edit-bank",
        query: { bank_id: bank }
      });
    },
    getCountriesList: function(country_id) {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            if (country_id) {
              this.Countries.map(x => {
                if (country_id === x.country_id) {
                  this.selected.Country = x.country_name;
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getStatesList: function(country_id, state_id) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;

            // console.log("States ", this.States);
            // console.log("States Id ", state_id);

            if (state_id) {
              this.States.map(x => {
                if (state_id === x.state_id) {
                  this.selected.State = x.state_name;
                  // console.log(" this.selected.State ", this.selected.State);
                }
              });
            }
          } else {
            // this.$toasted.show("state"+data.message);
          }
        })
        .catch(this._CatchError);
    },
    getCitiesList: function(state_id, city_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
            if (city_id) {
              this.Cities.map(x => {
                if (city_id === x.city_id) {
                  this.selected.City = x.city_name;
                }
              });
            }
          } else {
            //  this.$toasted.show("City"+data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/bankComponents/viewBank.vue